var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"frame",staticClass:"legacyCockpitFrame",attrs:{"allowTransparency":"true"}}),(_vm.isHybridFleetManagementPage)?_c('vehicle-details',{ref:"vehicleDetails",on:{"close":_vm.onCloseVehicleDetailsModal}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }